import ApiProvider from "../../../lib/providers/ApiProvider";
import { serviceUtil } from "../../commons/utils/services";
import { HeadersMapping } from "../../commons/mappings/headers.mapping";
import { URLConfiguration } from "../../commons/constants/url.configuration";
import ActualizarInformacionRequest from "./../../commons/mappings/actualizarInformacionRequest.mapping";

class ActualizarInformacionProvider {
    
    constructor() {
        this.paths                          = URLConfiguration.paths;
        this.actualizarInformacionRequest   = new ActualizarInformacionRequest();
        this.apiProvider                    = new ApiProvider(process.env.REACT_APP_BASE_SERVICE_PATH)
    }

    patchActualizarInformacion = async (datosConsulta) => {
        const headers   = HeadersMapping.getHeaderService();
        const request   = this.actualizarInformacionRequest.patchActualizarInformacion(datosConsulta);
        const pathNew   = serviceUtil.replaceParamUrl(this.paths.simulacionProductosRentas.actualizaInformacion, { idSimulacion: datosConsulta.idSimulacion });
        let response    = null;
        try {
            response = await this.apiProvider.patch( pathNew, request, { headers } );
        } catch (error) {
            console.log(error);
        }
        return response;
    }

}

export default ActualizarInformacionProvider;